<template>
<div class="section">
  <ul class="custom-nav nav mb-4" id="myTab" role="tablist">
    <li :class="validationNav ? 'nav-item active' : 'nav-item'">
      <a class="nav-link" id="validacao-tab" data-toggle="tab" href="#validacao" role="tab" aria-controls="validacao" aria-selected="true" @click="navSelected('VALIDATION_NAV')">Validação</a>
    </li>
    <li :class="orderDataNav ? 'nav-item active' : 'nav-item'">
      <a class="nav-link" id="dados-pedido-tab" data-toggle="tab" href="#dados-pedido" role="tab" aria-controls="dados-pedido" aria-selected="false" @click="navSelected('ORDER_DATA_NAV')">Dados do pedido</a>
    </li>
    <li :class="contactNav ? 'nav-item active' : 'nav-item'">
      <a class="nav-link" id="contato-tab" data-toggle="tab" href="#contato" role="tab" aria-controls="contato" aria-selected="false" @click="navSelected('CONTACT_NAV')">Contato</a>
    </li>
    <li :class="ordersNav ? 'nav-item active' : 'nav-item'">
      <a class="nav-link" id="pedidos-tab" data-toggle="tab" href="#pedidos" role="tab" aria-controls="pedidos" aria-selected="false" @click="navSelected('ORDERS_NAV')">
      <span>Pedidos</span>
      <!-- <span class="badge badge-primary badge-pill">125</span> -->
      </a>
    </li>
    <li :class="timelineNav ? 'nav-item active' : 'nav-item'">
      <a class="nav-link" id="timeline-tab" data-toggle="tab" href="#timeline" role="tab" aria-controls="timeline" aria-selected="false" @click="navSelected('TIMELINE_NAV')">Timeline das atividades</a>
    </li>
  </ul>

  <div class="tab-content border-0" id="myTabContent">
    <div class="tab-pane fade show active" id="validacao" role="tabpanel" aria-labelledby="validacao-tab">

      <div class="layout">
        <div class="layout-aside">
          <div class="custom-vert-nav nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <a class="nav-link active" id="v-pills-jornada-tab" data-toggle="pill" href="#v-pills-jornada" role="tab" aria-controls="v-pills-jornada" aria-selected="true">
              <span><strong>1</strong> - Jornada</span>
            </a>
            <a class="nav-link" id="v-pills-dados-pessoais-tab" data-toggle="pill" href="#v-pills-dados-pessoais" role="tab" aria-controls="v-pills-dados-pessoais" aria-selected="false">
              <span><strong>2</strong> - Dados pessoais</span>
            </a>
            <a class="nav-link" id="v-pills-aprovacao-tab" data-toggle="pill" href="#v-pills-aprovacao" role="tab" aria-controls="v-pills-aprovacao" aria-selected="false">
              <span><strong>3</strong> - Aprovação</span>
            </a>
          </div>
        </div>

        <div class="layout-content">
          <div class="tab-content border-0" id="v-pills-tabContent">
            <div class="tab-pane fade show active" id="v-pills-jornada" role="tabpanel" aria-labelledby="v-pills-jornada-tab">
              <validation-show @onloadimages="loadImages"/>
            </div>
            <div class="tab-pane fade" id="v-pills-dados-pessoais" role="tabpanel" aria-labelledby="v-pills-dados-pessoais-tab">
              <personal-data :user="user" :backCheck="backCheck" :idCheck="idCheck" :faceCheck="faceCheck" :validation="validation" :facebook="facebook" :transaction="transaction" :shipping="shipping" :reference="reference" :tx="tx"/>
              <validation-images :images="allImages"/>
            </div>
            <div class="tab-pane fade" id="v-pills-aprovacao" role="tabpanel" aria-labelledby="v-pills-aprovacao-tab">
              <approval-data
                :name="name"
                :cpf="cpf"
                :motherName="motherName"
                :birthDate="birthDate"
                :comment="comment"
                :phoneNumber="phoneNumber"
                :tx="tx"
                :backCheck="backCheck"
                :reference="reference"
                :user="user"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tab-pane fade" id="dados-pedido" role="tabpanel" aria-labelledby="dados-pedido-tab">
      <background-check :user="user" :backCheck="backCheck" :idCheck="idCheck" :facebook="facebook" :rating="rating" :tx="tx" :sellerStatus="sellerStatus"/>
      <order-details-component :cart="cart" :reference="reference" :payment="payment" :shipping="shipping" :sellerStatus="sellerStatus" :cartUrl="cartUrl" />
    </div>

    <div class="tab-pane fade" id="contato" role="tabpanel" aria-labelledby="contato-tab">
      <contact-phone-manager :user="user" :tx="tx" :reference="reference" />
      <contact-email-manager :user="user" :tx="tx" :reference="reference" />
    </div>

    <div class="tab-pane fade" id="pedidos" role="tabpanel" aria-labelledby="pedidos-tab">
      <orders :cpf="cpf"/>
    </div>

    <div class="tab-pane fade" id="timeline" role="tabpanel" aria-labelledby="timeline-tab">
      <timeline-menu :timeline="timeline"/>
    </div>
  </div>
</div>
</template>

<script>
import ValidationShow from './ValidationShow'
import PersonalData from '../cards/verification/PersonalData'
import OrderDetails from '../cards/order/OrderDetails'
import ContactPhoneManager from '../cards/contacts/ContactPhoneManager'
import ContactEmailManager from '../cards/contacts/ContactEmailManager'
import ApprovalData from './ApprovalData'
import BackgroundCheck from '../../partial/cards/verification/BackgroundCheckNew'
import ValidationImages from './ValidationImages.vue'
import Orders from '../order/Orders'
import TimelineMenu from '../timeline/TimelineMenu'

export default {
  components: {
    'validation-show': ValidationShow,
    'order-details-component': OrderDetails,
    'personal-data': PersonalData,
    'contact-phone-manager': ContactPhoneManager,
    'contact-email-manager': ContactEmailManager,
    'approval-data': ApprovalData,
    'background-check': BackgroundCheck,
    'validation-images': ValidationImages,
    'orders': Orders,
    'timeline-menu': TimelineMenu
  },
  data () {
    return {
      validationNav: false,
      orderDataNav: false,
      contactNav: false,
      ordersNav: false,
      timelineNav: false,
      allImages: null
    }
  },
  mounted () {
    this.validationNav = true
  },
  methods: {
    navSelected (nav) {
      this.orderDataNav = false
      this.contactNav = false
      this.validationNav = false
      this.ordersNav = false
      this.timelineNav = false

      if (nav === 'VALIDATION_NAV') {
        this.validationNav = true
      }
      if (nav === 'ORDER_DATA_NAV') {
        this.orderDataNav = true
      }
      if (nav === 'CONTACT_NAV') {
        this.contactNav = true
      }
      if (nav === 'ORDERS_NAV') {
        this.ordersNav = true
      }
      if (nav === 'TIMELINE_NAV') {
        this.timelineNav = true
      }
    },
    loadImages (allImages) {
      this.allImages = allImages
    }
  },
  props: [
    'user',
    'backCheck',
    'idCheck',
    'faceCheck',
    'validation',
    'facebook',
    'transaction',
    'shipping',
    'reference',
    'tx',
    'name',
    'cpf',
    'motherName',
    'birthDate',
    'comment',
    'phoneNumber',
    'cart',
    'payment',
    'sellerStatus',
    'cartUrl',
    'rating',
    'timeline'
  ]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/partial/validations/ValidationNav.vue